import React from "react";
import Check from "mdi-material-ui/Check";

/******************************************************************
 * Full-width success-style card for questionnaire submit / completed state.
 * Custom layout (no MUI Alert); styles from globals.css (.questionnaire-success-card).
 * Order: questionnaire title → row (check icon + status headline, side by side).
 ******************************************************************/
function QuestionnaireSuccessCard({ questionnaireTitle, headline }) {
  return (
    <div className="questionnaire-success-card" role="status">
      <h2 className="questionnaire-success-card__headline">{questionnaireTitle}</h2>
      <div className="questionnaire-success-card__status-row">
        <div className="questionnaire-success-card__icon-ring" aria-hidden>
          <Check className="questionnaire-success-card__check-icon" />
        </div>
        <p className="questionnaire-success-card__subtitle">{headline}</p>
      </div>
    </div>
  );
}

export default QuestionnaireSuccessCard;
